
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'プライバシーポリシー｜さかなの木';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="pt-32 pb-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-xs text-center mb-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>プライバシーポリシー｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>
            <h2 className="text-4xl font-bold text-[#3A3D3F] mb-8 text-center">
              プライバシーポリシー
            </h2>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の取り扱いについて
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  さかなの木（以下「当店」といいます）は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます）を遵守すると共に、以下のプライバシーポリシー（以下「本ポリシー」といいます）に従い、適切な取扱い及び保護に努めます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の定義
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます）、もしくは個人識別符号が含まれる情報を意味するものとします。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の収集方法
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed mb-4">
                  当店は、以下の方法により個人情報を収集することがあります。
                </p>
                <ul className="space-y-2 text-[#3A3D3F]">
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>ご予約時にお電話またはLINEでお伺いする情報</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>お問い合わせ時にご提供いただく情報</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>テイクアウトご注文時にご提供いただく情報</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の利用目的
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed mb-4">
                  当店は、お客様から収集した個人情報を以下の目的で利用いたします。
                </p>
                <ul className="space-y-2 text-[#3A3D3F]">
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>ご予約の確認及び管理</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>お問い合わせへの対応</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>テイクアウト商品のご注文対応</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>当店からのお知らせやキャンペーン情報の配信</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>サービスの改善及び新サービスの開発</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の第三者提供
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  当店は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
                </p>
                <ul className="space-y-2 text-[#3A3D3F] mt-4">
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>法令に基づく場合</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-brand mt-1">•</span>
                    <span>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の安全管理
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  当店は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当店の従業員に対し、必要かつ適切な監督を行います。また、個人情報の取扱いを委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  個人情報の開示・訂正・削除
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  お客様は、当店に対してご自身の個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、当店所定の手続きにより、請求することができます。具体的な手続きにつきましては、下記のお問い合わせ先までご連絡ください。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  Cookie（クッキー）について
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  当店のウェブサイトでは、より良いサービスの提供のため、Cookieを使用することがあります。Cookieの使用により個人を特定できる情報を取得することはありません。また、お客様はブラウザの設定によりCookieの受け取りを拒否することができます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  プライバシーポリシーの変更
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed">
                  当店は、法令の変更等に伴い、本ポリシーを変更することがあります。変更後のプライバシーポリシーは、当店ウェブサイトに掲載した時点で効力を生じるものとします。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#3A3D3F] mb-4 pl-4 border-l-4 border-brand">
                  お問い合わせ窓口
                </h2>
                <p className="text-[#3A3D3F] leading-relaxed mb-4">
                  個人情報の取扱いに関するお問い合わせは、以下の窓口までご連絡ください。
                </p>
                <div className="bg-[#d4edeb] rounded-lg p-6">
                  <p className="text-[#3A3D3F] mb-2"><strong>店名:</strong> さかなの木</p>
                  <p className="text-[#3A3D3F] mb-2"><strong>住所:</strong> 〒146-0091 東京都大田区鵜の木2-5-5 イーグル鵜の木原田ビル1階G号</p>
                  <p className="text-[#3A3D3F] mb-2">
                    <strong>電話:</strong> <a href="tel:03-6715-0369" className="text-brand hover:underline cursor-pointer">03-6715-0369</a>
                  </p>
                  <p className="text-[#3A3D3F]">
                    <strong>メール:</strong> <a href="mailto:sakananoki0808@gmail.com" className="text-brand hover:underline cursor-pointer">sakananoki0808@gmail.com</a>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
